module.exports = __webpack_public_path__ + "static/media/microsoftExcel.4d0a13c2.svg";